export type ParsePublicationExpiresAtResult =
  | { ok: true; iso: string | null }
  | { ok: false; message: string };

export function toPublicationExpiresAtLocalValue(value?: string | null): string {
  if (!value)
  {
    return '';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime()))
  {
    return '';
  }

  const pad = (part: number): string => part.toString().padStart(2, '0');
  return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}T${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
}

export function isPublicationExpirationValid(value: string): boolean {
  if (!value)
  {
    return true;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime()))
  {
    return false;
  }

  return parsed.getTime() > Date.now();
}

export function parsePublicationExpiresAtInput(value: string): ParsePublicationExpiresAtResult {
  if (!value.trim())
  {
    return { ok: true, iso: null };
  }

  if (!isPublicationExpirationValid(value))
  {
    return { ok: false, message: 'A validade da publicação deve ser uma data e hora futuras.' };
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime()))
  {
    return { ok: false, message: 'A validade da publicação deve ser uma data e hora futuras.' };
  }

  return { ok: true, iso: parsed.toISOString() };
}
